import CollectionClass, * as CollectionModule from './../node_modules/ol/Collection.js';

// Create a wrapper class
class Collection extends CollectionClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in CollectionModule) {
    if (key !== "default") {
        Collection[key] = CollectionModule[key];
    }
}

export default Collection;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Collection.js';